import Vue from 'vue'
import VueRouter from 'vue-router'

import CladifyPortal from '../views/CladifyPortal.vue'
import CustomerPortal from '../views/CustomerPortal.vue'

import Authentication from '../views/Authentication.vue'

import Home from '../views/Home.vue'

import Documents from '../views/Documents.vue'

import AdminPanel from '../views/AdminPanel.vue'
import UserList from '../views/UserList.vue'
import Permissions from '../views/Permissions'
import Tickets from '../views/Tickets.vue'
import TicketList from '../views/TicketList.vue'
import TicketMaker from '../views/TicketMaker.vue'
import TicketViewer from '../views/TicketViewer.vue'
import TicketCompanies from '../views/TicketCompanies.vue'
import TicketCompanyList from '../views/TicketCompanyList.vue'
import TicketCompanyViewer from '../views/TicketCompanyViewer.vue'
import TicketContacts from '../views/TicketContacts.vue'

import SampleRequests from '../views/SampleRequests.vue'
import SampleList from '../views/SampleList.vue'
import SampleRequestList from '../views/SampleRequestList.vue'
import SampleRequestMaker from '../views/SampleRequestMaker.vue'
import SampleRequestViewer from '../views/SampleRequestViewer.vue'

import EstimationDashboard from '../views/EstimationDashboard'
import RFQs from '../views/RFQs'
import RfqMaker from '../views/RfqMaker'
import RfqViewer from '../views/RfqViewer'
import DrawingHighlightList from '../views/DrawingHighlightList'
import DrawingHighlightViewer from '../views/DrawingHighlightViewer'
import Estimations from '../views/Estimations'
import EstimationList from '../views/EstimationList'
import EstimationMaker from '../views/EstimationMaker'
import EstimationViewer from '../views/EstimationViewer'
import EstimationViewerCladify from '../views/EstimationViewerCladify'
import EstimationViewerMitrex from '../views/EstimationViewerMitrex'
import InstallationMethods from '../views/InstallationMethods'

import Proposals from '../views/Proposals.vue'
import ProposalMaker from '../views/ProposalMaker.vue'

import CutSheets from '../views/CutSheets.vue'
import CutSheetList from '../views/CutSheetList.vue'
import CutSheetMaker from '../views/CutSheetMaker.vue'
import CutSheetEditor from '../views/CutSheetEditor.vue'
import CutSheetViewer from '../views/CutSheetViewer.vue'
import CutSheetAssembly from '../views/CutSheetAssembly.vue'
import CutSheetAssemblyList from '../views/CutSheetAssemblyList.vue'
import CutSheetAssemblyCreate from '../views/CutSheetAssemblyCreate.vue'
import CutSheetAssemblyView from '../views/CutSheetAssemblyView.vue'

import Storages from '../views/Storages.vue'
import StorageList from '../views/StorageList.vue'
import StorageMaker from '../views/StorageMaker.vue'
import StorageViewer from '../views/StorageViewer.vue'

import Inventory from '../views/Inventory.vue'
import Products from '../views/Products.vue'
import Orders from '../views/Orders.vue'
import OrderList from '../views/OrderList.vue'
import OrderViewer from '../views/OrderViewer'
import OrderMaker from '../views/OrderMaker'
import Suppliers from '../views/Suppliers.vue'
import Boms from '../views/Boms.vue'
import BomList from '../views/BomList.vue'
import BomMaker from '../views/BomMaker.vue'
import BomViewer from '../views/BomViewer.vue'
import ProductionSheets from '../views/ProductionSheets'
import ProductionSheetList from '../views/ProductionSheetList'
import ProductionSheetMaker from '../views/ProductionSheetMaker'
import ProductionSheetViewer from '../views/ProductionSheetViewer'
import ProductionSheetItems from '../views/ProductionSheetItems'
import InventoryManagement from '../views/InventoryManagement'

import Production from '../views/Production'
import ProductionStatus from '../views/ProductionStatus'
import ProductionTaskManagement from '../views/ProductionTaskManagement'
import ScheduleMaker from '../views/ScheduleMaker'
import Workstations from '../views/Workstations'
import WorkSteps from '../views/WorkSteps'

import Warehousing from '../views/Warehousing'
import WarehouseLocations from '../views/WarehouseLocations'
import WarehouseLocationViewer from '../views/WarehouseLocationViewer'

import Deliveries from '../views/Deliveries'
import DeliveryList from '../views/DeliveryList'
import DeliveryMaker from '../views/DeliveryMaker'
import DeliveryViewer from '../views/DeliveryViewer'

import EstimationPreview from '../views/EstimationPreview'
import LinkExpired from '../views/LinkExpired'

import MitrexCalculator from '../views/MitrexCalculator'

import InstallationSummary from '../views/InstallationSummary'
import InstallationProjects from '../views/InstallationProjects'
import InstallationDefectedProjects from '../views/InstallationDefectedProjects'
import InstallationDefectedItems from '../views/InstallationDefectedItems'
import InstallationItems from '../views/InstallationItems'
import Skids from '../views/Skids'
import SkidList from '../views/SkidList'
import SkidViewer from '../views/SkidViewer'

import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['auth/isAuthenticated']) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/isAuthenticated']) {
    next()
    return
  }
  next('/authenticate')
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: CladifyPortal,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      { 
        path: 'admin',
        component: AdminPanel,
        children: [
          {
            path: 'users',
            name: 'UserList',
            component: UserList
          },
          {
            path: 'permissions',
            name: 'Permissions',
            component: Permissions
          }
        ] 
      },
      {
        path: 'estimations',
        component: Estimations,
        children: [
          {
            path: 'dashboard',
            name: 'EstimationDashboard',
            component: EstimationDashboard,
            props: true
          },
          {
            path: 'rfqs',
            name: 'RFQs',
            component: RFQs
          },
          {
            path: 'rfqs/create/:productBrand',
            name: 'RfqMaker',
            component: RfqMaker
          },
          {
            path: 'rfqs/view/:rfqId',
            name: 'RfqViewer',
            component: RfqViewer,
            props: true
          },
          {
            path: 'drawinghighlights',
            name: 'DrawingHighlights',
            component: DrawingHighlightList
          },
          {
            path: 'drawinghighlights/view/:drawingHighlightId',
            name: 'DrawingHighlightViewer',
            component: DrawingHighlightViewer,
            props: true
          },
          {        
            path: '',
            name: 'Estimations',
            component: EstimationList,
            props: true
          },
          {
            path: 'create/:rfqId?',
            name: 'EstimationMaker',
            component: EstimationMaker,
            props: true
          },
          {
            path: 'view/:estimationId',
            name: 'EstimationViewer',
            component: EstimationViewer,
            props: true
          },
          {
            path: 'view/cladify/:estimationId',
            name: 'EstimationViewerCladify',
            component: EstimationViewerCladify,
            props: true
          },
          {
            path: 'view/mitrex/:estimationId',
            name: 'EstimationViewerMitrex',
            component: EstimationViewerMitrex,
            props: true
          }
        ]
      },
      {
        path: 'installationmethods',
        name: 'InstallationMethods',
        component: InstallationMethods
      },
      {
        path: 'proposals/:product',
        name: 'Proposals',
        component: Proposals,
        props: true
      },
      {
        path: 'proposalmaker/:projectId/:proposalId',
        name: 'ProposalMaker',
        component: ProposalMaker,
        props: true
      },
      {
        path: 'documents/:documentTypeId?',
        name: 'Documents',
        component: Documents
      },
      {
        path: 'samples',
        component: SampleRequests,
        children: [
          {
            path: '',
            name: 'Samples',
            component: SampleList
          },
          {
            path: 'requests',
            name: 'SampleRequests',
            component: SampleRequestList
          },
          {
            path: 'create',
            name: 'SampleRequestMaker',
            component: SampleRequestMaker
          },
          {
            path: 'view/:requestId',
            name: 'SampleRequestViewer',
            component: SampleRequestViewer,
            props: true
          }
        ]
      },
      { 
        path: 'tickets',
        component: Tickets,
        props: true,
        children: [
          {
            path: '',
            name: 'Tickets',
            component: TicketList
          },
          {
            path: 'create',
            name: 'TicketMaker',
            component: TicketMaker
          },
          {
            path: 'ticket/:ticketId',
            name: 'TicketViewer',
            props: true,
            component: TicketViewer
          },
          {
            path: 'companies',
            component: TicketCompanies,
            props: true,
            children: [
              {
                path: '',
                name: 'TicketCompanies',
                component: TicketCompanyList
              },
              {
                path: ':companyId',
                name: 'TicketCompanyViewer',
                props: true,
                component: TicketCompanyViewer
              }
            ]
          },
          {
            path: 'contacts',
            name: 'TicketContacts',
            props: true,
            component: TicketContacts
          }
        ] 
      },
      {
        path: 'cutsheets',
        component: CutSheets,
        props: true,
        children: [
          {
            path: '',
            name: 'CutSheets',
            component: CutSheetList
          },
          {
            path: 'create',
            name: 'CutSheetMaker',
            component: CutSheetMaker
          },
          {
            path: 'edit/:cutSheetId',
            name: 'CutSheetEditor',
            component: CutSheetEditor,
            props: true
          },
          {
            path: 'view/:cutSheetId',
            name: 'CutSheetViewer',
            component: CutSheetViewer,
            props: true
          }
        ]
      },
      {
        path: 'assembly',
        component: CutSheetAssembly,
        props: true,
        children: [
          {
            path: '',
            name: 'AssemblyList',
            component: CutSheetAssemblyList
          },
          {
            path: 'create',
            name: 'AssemblyCreate',
            component: CutSheetAssemblyCreate
          },
          {
            path: 'view/:assemblySheetId',
            name: 'AssemblyView',
            component: CutSheetAssemblyView,
            props: true
          }
        ]
      },
      {
        path: 'storages',
        component: Storages,
        props: true,
        children: [
          {
            path: '',
            name: 'StorageList',
            component: StorageList
          },
          {
            path: 'create',
            name: 'StorageMaker',
            component: StorageMaker
          },
          {
            path: 'view/:storageId',
            name: 'StorageViewer',
            component: StorageViewer,
            props: true
          }
        ]
      },
      {
        path: 'productionsheets',
        component: ProductionSheets,
        children: [
          { 
            path: '',
            name: 'ProductionSheets',
            component: ProductionSheetList
          },
          { 
            path: 'create',
            name: 'ProductionSheetMaker',
            component: ProductionSheetMaker
          },
          {
            path: 'view/:productionSheetId',
            name: 'ProductionSheetViewer',
            component: ProductionSheetViewer,
            props: true
          }
        ]
      },
      {
        path: 'inventory',
        props: true,
        component: Inventory,
        children: [
          {
            path: 'manage',
            name: 'InventoryManagement',
            component: InventoryManagement
          },
          {
            path: 'slabs',
            name: 'ProductionSheetItems',
            component: ProductionSheetItems
          },
          {
            path: 'boms',
            component: Boms,
            children: [
              { 
                path: '',
                name: 'Boms',
                component: BomList
              },
              { 
                path: 'create',
                name: 'BomMaker',
                component: BomMaker
              },
              {
                path: 'view/:bomId',
                name: 'BomViewer',
                component: BomViewer,
                props: true
              }
            ]
          },
          {
            path: 'orders',
            component: Orders,
            children: [
              { 
                path: '',
                name: 'Orders',
                component: OrderList
              },
              { 
                path: 'create',
                name: 'OrderMaker',
                component: OrderMaker
              },
              {
                path: 'view/:orderId',
                name: 'OrderViewer',
                component: OrderViewer,
                props: true
              }
            ]
          },
          {
            path: 'products',
            name: 'Products',
            component: Products
          },
          {
            path: 'suppliers',
            name: 'Suppliers',
            component: Suppliers
          }
        ]
      },
      {
        path: 'production',
        props: true,
        component: Production,
        children: [
          { 
            path: 'scheduler', 
            name: 'ScheduleMaker',
            component: ScheduleMaker
          },
          { 
            path: 'status', 
            name: 'ProductionStatus',
            component: ProductionStatus
          },
          { 
            path: 'tasks', 
            name: 'ProductionTaskManagement',
            component: ProductionTaskManagement
          },
          {
            path: 'workstations',
            name: 'Workstations',
            component: Workstations
          },
          {
            path: 'worksteps',
            name: 'WorkSteps',
            component: WorkSteps
          }
        ]
      },
      {
        path: 'warehousing',
        props: true,
        component: Warehousing,
        children: [
          { 
            path: 'locations', 
            name: 'WarehouseLocations',
            component: WarehouseLocations
          },
          {
            path: 'locations/view/:locationId',
            name: 'WarehouseLocationViewer',
            component: WarehouseLocationViewer,
            props: true
          }
        ]
      },
      {
        path: 'deliveries',
        props: true,
        component: Deliveries,
        children: [
          { 
            path: '', 
            name: 'DeliveryList',
            component: DeliveryList
          },
          { 
            path: 'create', 
            name: 'DeliveryMaker',
            component: DeliveryMaker
          },
          { 
            path: 'view/:deliveryId', 
            name: 'DeliveryViewer',
            component: DeliveryViewer
          }
        ]
      },
      {
        path: 'installationsummary',
        props: true,
        component: InstallationSummary,
        name: 'InstallationSummary'
      },
      {
        path: 'installationprojects',
        props: true,
        component: InstallationProjects,
        name: 'InstallationProjects'
      },
      {
        path: 'installationdefectedprojects',
        props: true,
        component: InstallationDefectedProjects,
        name: 'InstallationDefectedProjects'
      },
      {
        path: 'defecteditems',
        props: true,
        component: InstallationDefectedItems,
        name: 'InstallationDefectedItems'
      },
      {
        path: 'skids',
        props: true,
        component: Skids,
        children: [
          { 
            path: '', 
            name: 'SkidList',
            component: SkidList
          },
          {
            path: 'view/:skidId?',
            name: 'SkidViewer',
            component: SkidViewer
          }
        ]
      },
      {
        path: 'installationitems',
        props: true,
        component: InstallationItems,
        name: 'InstallationItems'
      }
    ]
  },
  {
    path: '/authenticate',
    name: 'Authentication',
    component: Authentication,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/customerportal',
    name: 'CustomerPortal',
    component: CustomerPortal,
    children: [
      {
        path: 'estimationpreview/:apiToken',
        name: 'EstimationPreview',
        component: EstimationPreview,
        props: true
      },
      {
        path: 'linkexpired',
        name: 'LinkExpired',
        component: LinkExpired
      }
    ]
  },
  {
    path: '/mitrexcalculator',
    name: 'MitrexCalculator',
    component: MitrexCalculator
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    } if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes
})

export default router
